import React, { PropTypes } from "react";
import { FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import validationUtils from "../../../../../utils/ValidationUtils";
import { createDataItem } from "../../../../../utils/data/dataActions";
import { CLIENTS } from "../../../../../utils/data/models";
import { RECURRING } from "../../enums/billingPeriodTypes";
import { IMPORT_SALARIES_VALIDATION_RULES } from "./bulkSalariesValidationRules";

import moment from "moment";
import { BSModal, MessageBox } from "../../../../common";
import { getRetroactiveBeginningDate, getRetroactiveLimitDate } from "../../../../common/RetroactiveData/RetroactiveLimitHelper";
import { RETROACTIVE_LIMIT_ERROR } from "../../../../common/enums/apiHooksErrorType";
import { DayPicker, FileInput } from "../../../../common/form";
import { TERMINATED } from "../../enums/clientStatusTypes";
import userHasAccess from "../../../../../utils/userHasAccess";
import { FINTECH } from "../../../../../utils/Roles";
class ImportSalaries extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmationActions: [],
      confirmationMessage: "",
      response: {},
      showConfirmationModal: false,
      showSuccessDetailsModal: false,
      successDetailMessage: "",
      successDetailTitle: "",
      maximumRetroactiveDate: undefined,
      fetchingMaximumRetroactiveDate: true
    };

    this.closeConfirmation = this.closeConfirmation.bind(this);
    this.confirmSalariesImport = this.confirmSalariesImport.bind(this);
    this.importSalaries = this.importSalaries.bind(this);
    this.openSuccessDetails = this.openSuccessDetails.bind(this);
    this.closeSuccessDetails = this.closeSuccessDetails.bind(this);
    this.renderSuccessDetailsMessage = this.renderSuccessDetailsMessage.bind(
      this
    );
    this.renderSuccessDetailsTitle = this.renderSuccessDetailsTitle.bind(this);
    this.renderSuccessAlertMessage = this.renderSuccessAlertMessage.bind(this);
    this.setmaximumRetroactiveDate = this.setmaximumRetroactiveDate.bind(this);
    this.getSixMonthsAgoDate = this.getSixMonthsAgoDate.bind(this);
  }

  componentDidMount() {
    this.setmaximumRetroactiveDate();
  }

  getSixMonthsAgoDate() {
    // Get the current date
    const currentDate = new Date();

    // Create a new date object set to the current date
    const sixMonthsAgo = new Date(currentDate);

    // Adjust the month by subtracting 6
    sixMonthsAgo.setMonth(currentDate.getMonth() - 6);
    sixMonthsAgo.setDate(1);

    // Return the adjusted date
    return sixMonthsAgo;
  }

  setmaximumRetroactiveDate() {
    getRetroactiveLimitDate(this.props.client.clientId, (result) => {
      this.setState({
        maximumRetroactiveDate: result,
        fetchingMaximumRetroactiveDate: false
      });
    });

  }

  closeConfirmation() {
    this.setState({ showConfirmationModal: false });
  }

  confirmSalariesImport(values) {
    this.setState({
      showConfirmationModal: true,
      confirmationMessage: this.renderConfirmationMessage(values),
      confirmationActions: [
        {
          id: 1,
          text: <FormattedMessage id="common.confirm" />,
          action: () => {
            this.importSalaries(values);
            this.closeConfirmation();
          },
        },
      ],
    });
  }

  importSalaries(values) {
    const {
      client: { clientId },
      createDataItem,
    } = this.props;
    this.setState({ importing: true });
    values["clientId"] = clientId;
    values["effectiveDate"] = new Date(values["effectiveDate"]).toISOString().split('T')[0];
    let model = {
      ...CLIENTS,
      path: `${CLIENTS.path}/${clientId}/import-salaries`,
    };
    let formData = new FormData();

    let query = {};

    Object.keys(values).map((key) => {
      if (key == "file") {
        formData.append(key, values[key][0]);
      } else {
        query[key] = values[key];
      }
    });

    return createDataItem(
      model,
      formData,
      {},
      { contentType: "formData" },
      query
    ).then((data) => {
      this.setState({
        response: data.payload,
        importing: false,
      });
    });
  }

  renderConfirmationMessage(values) {
    const { formatDate } = this.context.intl;
    const { effectiveDate, file } = values;
    const dateFormat = {
      year: "numeric",
      month: "long",
      day: "2-digit",
      timeZone: "UTC",
    };
    const formattedEffectiveDate = formatDate(effectiveDate, dateFormat);
    const fileName = file[0].name;

    return (
      <div className="formatted-confirmation">
        <p>
          <FormattedMessage id="bulkSalaries.importSalaries.confirmation.message" />
        </p>
        <p>
          <FormattedMessage
            id="bulkSalaries.importSalaries.form.effectiveDate"
            tagName="strong"
          />
          <span>{formattedEffectiveDate}</span>
        </p>
        <p>
          <FormattedMessage
            tagName="strong"
            id="bulkSalaries.importSalaries.confirmation.fileName"
          />
          <span>{fileName}</span>
        </p>
      </div>
    );
  }

  renderConfirmationTitle() {
    return (
      <FormattedMessage id="bulkSalaries.importSalaries.confirmation.title">
        {(m) => <span className="icon warning">{m}</span>}
      </FormattedMessage>
    );
  }

  renderSuccessDetailsMessage(values) {
    const list = values.map((member, i) => {
      return (
        <li key={i}>
          {member.firstName} {member.lastName}{" "}
          <span className="member-id">{member.memberIdentifier}</span>
        </li>
      );
    });
    return <ul>{list}</ul>;
  }

  renderSuccessDetailsTitle(type) {
    return (
      <FormattedMessage
        id={`bulkSalaries.importSalaries.messages.success.modal.${type}.title`}
      />
    );
  }

  openSuccessDetails(responseItem, responseType) {
    this.setState({
      showSuccessDetailsModal: true,
      successDetailMessage: this.renderSuccessDetailsMessage(responseItem),
      successDetailTitle: this.renderSuccessDetailsTitle(responseType),
    });
  }

  closeSuccessDetails() {
    this.setState({ showSuccessDetailsModal: false });
  }

  renderSuccessAlertMessage(data) {
    const successMessageDetails = Object.keys(data).map((category) => {
      const count = data[category].length;

      if (count) {
        return (
          <p key={category}>
            <a
              href="#"
              onClick={() => this.openSuccessDetails(data[category], category)}
            >
              <FormattedMessage
                id="bulkSalaries.importSalaries.messages.success.linkText"
                values={{ number: count }}
              />
            </a>
            <FormattedMessage
              id={`bulkSalaries.importSalaries.messages.success.${category}`}
              values={{ number: count }}
            />
          </p>
        );
      }

      return null;
    });

    return (
      <div>
        <p>
          <FormattedMessage id="bulkSalaries.importSalaries.messages.success.generic" />
        </p>
        {successMessageDetails}
      </div>
    );
  }

  renderResponse() {
    const { response } = this.state;
    const isError = Object.keys(response)[0] === "error";
    let message = [];

    if (Object.keys(response).length > 0) {
      const data = isError ? response["error"].data : response.data;
      const className = isError ? "alert-danger" : "alert-success";
      let messageContent;

      if (isError) {
        const messageErrors = data.message;
        if (data.message == RETROACTIVE_LIMIT_ERROR.value) {
          messageContent = (
            <div>
              <p>
                <FormattedMessage id={RETROACTIVE_LIMIT_ERROR.value} />
              </p>
            </div>
          );
        } 
        
        else if(data.error === "import_column_error") {
          messageContent = <span><FormattedMessage id="importErrors.columnError" values={{fileNum: messageErrors.got, expectedNum: messageErrors.expecting, br: <br/>}}/></span>;
        }

        else if(data.error === "import_data_type_error") {
          const errorValue = messageErrors.includes(":") && messageErrors.split(": ")[1];
          if(errorValue) {
            messageContent = <span><FormattedMessage id="importErrors.dataTypeErrorWithValue" values={{value: errorValue}}/></span>;
          }
          else {
            messageContent = <span><FormattedMessage id="importErrors.dataTypeError"/></span>;
          }
        }
          
        else {
          messageContent = (
            <div>
              <p>
                <FormattedMessage id="bulkSalaries.importSalaries.messages.error" />
              </p>
              <p>{data.message}</p>
            </div>
          );
        }
      } else {
        messageContent = this.renderSuccessAlertMessage(data);
      }

      message = <MessageBox className={className}>{messageContent}</MessageBox>;
    }

    return message;
  }

  render() {
    const { handleSubmit, isArchived } = this.props;
    const { importing } = this.state;
    const {
      confirmationActions,
      confirmationMessage,
      showConfirmationModal,
      showSuccessDetailsModal,
      successDetailMessage,
      successDetailTitle,
      fetchingMaximumRetroactiveDate
    } = this.state;
    let maxRetroactiveDate = null;
    if (this.state.maximumRetroactiveDate) {
      maxRetroactiveDate = getRetroactiveBeginningDate(this.state.maximumRetroactiveDate);
    }
    else {
      maxRetroactiveDate = this.props.clientBillingPeriodType == RECURRING.value ? this.getSixMonthsAgoDate() : null;
    }
    const clientLastActiveDate = this.props.client.lastActiveDate ? moment(this.props.client.lastActiveDate) : undefined;
    const isTerminatedClient = this.props.client && this.props.client.clientStatusType === TERMINATED.value && !userHasAccess(FINTECH);

    return (
      <div className="import-export import-salaries">
        <form
          onSubmit={handleSubmit(this.confirmSalariesImport)}
          className="import-salaries-form"
        >
          {this.renderResponse()}
          <h3>
            <FormattedMessage id="bulkSalaries.importSalaries.title" />
          </h3>

          <Field
            id="effectiveDate"
            name="effectiveDate"
            component={DayPicker}
            showClearButton={true}
            utc={false}
            disabled={isArchived || fetchingMaximumRetroactiveDate === true || isTerminatedClient}
            minDate={maxRetroactiveDate}
            maxDate={clientLastActiveDate}
            label={
              <FormattedMessage id="bulkSalaries.importSalaries.form.effectiveDate" />
            }
          />
          {clientLastActiveDate && (
            <MessageBox className="alert-warning">
              <FormattedMessage id="pastLastActiveDateError" />
            </MessageBox>
          )}

          <Field
            id="file"
            name="file"
            component={FileInput}
            disabled={isArchived || isTerminatedClient}
            label={
              <FormattedMessage id="bulkSalaries.importSalaries.form.file" />
            }
            dropzoneLabel={
              <FormattedMessage id="bulkSalaries.importSalaries.form.fileDesc" />
            }
          />

          <div className="import-export-submit">
            <span className="import-export-button">
              <button
                type="submit"
                className="btn btn-lg btn-primary"
                disabled={isArchived || isTerminatedClient}
              >
                <FormattedMessage id="bulkSalaries.importSalaries.form.button" />
              </button>
            </span>
            {importing && (
              <span className="import-export-loader">
                <span className="loader">
                  <FormattedMessage id="bulkSalaries.importSalaries.form.importing" />
                </span>
              </span>
            )}
          </div>
        </form>

        <BSModal
          show={showConfirmationModal}
          title={this.renderConfirmationTitle()}
          actions={confirmationActions}
          onClose={this.closeConfirmation}
        >
          {confirmationMessage}
        </BSModal>
        <BSModal
          show={showSuccessDetailsModal}
          title={successDetailTitle}
          onClose={this.closeSuccessDetails}
          className="import-salaries-success-modal"
        >
          {successDetailMessage}
        </BSModal>
      </div>
    );
  }
}

ImportSalaries.propTypes = {
  client: PropTypes.object,
  createDataItem: PropTypes.func,
  handleSubmit: PropTypes.func,
  importing: PropTypes.bool,
  isArchived: PropTypes.bool,
  clientBillingPeriodType: PropTypes.string,
};

ImportSalaries.contextTypes = {
  intl: intlShape,
};

function mapStateToProps(state) {
  const clients = state.data.clients || {};
  const client = clients.active;
  return {
    client: client || {},
    isArchived: client ? client.isArchived : false,
    clientBillingPeriodType: client ? client.clientBillingPeriodType : null,
    importing: state.data.submitting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createDataItem: bindActionCreators(createDataItem, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(
  reduxForm({
    form: "importSalariesForm",
    validate: (values) =>
      validationUtils.validate(values, IMPORT_SALARIES_VALIDATION_RULES),
  })(ImportSalaries)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/bulkSalaries/ImportSalaries.js